var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.menuItems, function(menuItem, mi) {
        return !menuItem.loggedIn || _vm.loggedIn
          ? _c(
              "li",
              {
                staticClass: "menu-item",
                class: { "current-menu-item": menuItem.active }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "elementor-item",
                    class: { "elementor-item-active": menuItem.active },
                    attrs: { href: _vm.resolvedLink(menuItem.link) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.clickItem(menuItem)
                      }
                    }
                  },
                  [_vm._v("\n    " + _vm._s(menuItem.title) + "\n  ")]
                )
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }